// Create a new JavaScript file called moving-cowboy-hat.js

// Create the cowboy hat element
const cowboyHat = document.createElement('div');
cowboyHat.id = 'cowboy-hat';
cowboyHat.innerHTML = '🤠'; // Cowboy hat emoji
cowboyHat.style.cssText = `
  position: fixed;
  font-size: 40px;
  top: 20px;
  left: -40px;
  z-index: 9999;
  transition: left 10s linear;
`;

// Add the cowboy hat to the page
document.body.appendChild(cowboyHat);

// Function to move the hat
function moveHat() {
  setTimeout(() => {
    cowboyHat.style.left = `${window.innerWidth}px`;
  }, 100);
}

// Move the hat when the page loads
window.addEventListener('load', moveHat);

// Move the hat again when it finishes its journey
cowboyHat.addEventListener('transitionend', () => {
  cowboyHat.style.transition = 'none';
  cowboyHat.style.left = '-40px';
  setTimeout(() => {
    cowboyHat.style.transition = 'left 10s linear';
    moveHat();
  }, 100);
});